import React from 'react';
import {
  Button,
  Card,
  CardActions,
  CardContent,
  Grid,
  Typography,
} from '@mui/material';
import { styled } from '@mui/system';

const CTAButton = styled(Button)(() => ({
  transition: 'transform 0.2s ease-in-out, box-shadow 0.2s',
  boxShadow: '0 4px 10px rgba(0, 0, 0, 0.2)',
  backgroundColor: '#FFCC00', // Matching LifeCodeCreator button color
  color: '#121212',
  fontWeight: 'bold',
  fontSize: '1rem',
  padding: '10px 20px',
  borderRadius: '8px',
  width: '100%',
  textTransform: 'none',

  '&:hover': {
    transform: 'scale(1.05)',
    backgroundColor: '#ffdb4d',
    boxShadow: '0 6px 15px rgba(0, 0, 0, 0.3)',
  },
}));

export function Show(props) {
  const { product, isYearly, setPlan } = props;

  const defaultPrice = isYearly
    ? product.prices.find((price) => price.id !== product['default_price'])
    : product.prices.find((price) => price.id === product['default_price']);

  const metaData = Object.entries(product.metadata)
    .map(([key, value]) => ({ key, value }))
    .sort((a, b) => {
      if (a.value !== 'false' && b.value === 'false') return -1;
      if (a.value === 'false' && b.value !== 'false') return 1;
      if (a.key.includes('Everything included')) return -1;
      return 0;
    });

  return (
    <Card
      sx={{
        background: 'rgba(255, 255, 255, 0.15)', // Matches LifeCodeCreator & Modal
        borderRadius: '15px',
        boxShadow: '5px 5px 15px rgba(0, 0, 0, 0.3)',
        width: '100%',
        textAlign: 'center',
        backdropFilter: 'blur(12px)', // Blur effect for consistency
        p: 4,
      }}
    >
      <CardContent>
        <Typography
          variant="h5"
          sx={{
            fontWeight: 'bold',
            color: '#FFCC00', // Matching LifeCodeCreator
            textAlign: 'center',
            mb: 2,
          }}
        >
          {product.name}
        </Typography>
        <Typography
          variant="body2"
          sx={{ textAlign: 'center', color: '#ffffff', mb: 2 }}
        >
          {product.description}
        </Typography>
        <Typography
          variant="h4"
          sx={{
            fontWeight: 'bold',
            textAlign: 'center',
            mb: 2,
            color: '#ffffff',
          }}
        >
          {`$${defaultPrice.unit_amount_decimal.slice(
            0,
            defaultPrice.unit_amount_decimal.length - 2
          )}.${defaultPrice.unit_amount_decimal.slice(
            defaultPrice.unit_amount_decimal.length - 2
          )}`}
          <Typography
            variant="caption"
            sx={{ color: '#FFCC00', marginLeft: '5px' }}
          >
            {isYearly ? '/year' : '/month'}
          </Typography>
        </Typography>

        <CardActions>
          <CTAButton
            variant="contained"
            size="large"
            onClick={() => setPlan(defaultPrice.id)}
          >
            Get Started
          </CTAButton>
        </CardActions>
      </CardContent>

      {product.metadata && (
        <CardContent>
          <Typography
            variant="h6"
            sx={{
              textAlign: 'center',
              fontWeight: 'bold',
              color: '#FFCC00',
              mb: 2,
            }}
          >
            Features
          </Typography>
          <Grid container spacing={2}>
            {metaData.map((metadata, key) => (
              <Grid item xs={6} key={key}>
                <Typography
                  variant="subtitle2"
                  sx={{
                    fontWeight: 'bold',
                    color: '#ffffff',
                    marginBottom: '0.25rem',
                  }}
                >
                  ✅ {metadata.key}
                </Typography>
                <Typography variant="caption" sx={{ color: '#FFCC00' }}>
                  {metadata.value}
                </Typography>
              </Grid>
            ))}
          </Grid>
        </CardContent>
      )}
    </Card>
  );
}
